import {gql} from "@apollo/client";
import {Garage} from "@App/types";

export interface GarageSlotsQuery {
    garage: Garage
}

export const GET_GARAGE_SLOTS = gql`
    query getGarageSlots(
        $organization: ID!,
        $garage: ID,
        $services: [ID],
        $from: DateTimeTz!,
        $to: DateTimeTz!,
        $brand: ID,
        $generation: ID,
        $motorization: ID,
        $gearbox: ID,
        $body: ID,
        $mileage: Int,
        $registrationDate: Date,
        $subRepairs: [String],
        $equipments: [String],
        $premiumServices: [ID]
    ) {
        garage(id: $garage) {
            id
            earliestSlot(
                input: {
                    organization: $organization,
                    from: $from,
                    to: $to,
                    duration: 30
                    calculation: {
                        services: $services
                        brand: $brand
                        generation: $generation
                        motorization: $motorization
                        mileage: $mileage
                        gearbox: $gearbox
                        body: $body
                        registration_date: $registrationDate
                        sub_repairs: $subRepairs
                        equipments: $equipments
                        premiumServices: $premiumServices
                    }
                }
            ) {
                starts_at
                ends_at
                calendar_id
            }
            slots(
                input: {
                    organization: $organization,
                    from: $from,
                    to: $to,
                    duration: 30
                    calculation: {
                        services: $services
                        brand: $brand
                        generation: $generation
                        motorization: $motorization
                        mileage: $mileage
                        gearbox: $gearbox
                        body: $body
                        registration_date: $registrationDate
                        sub_repairs: $subRepairs
                        equipments: $equipments
                        premiumServices: $premiumServices
                    }
                }
            ) {
                starts_at
                ends_at
                calendar_id
            }
        }
    }
`
